import React from 'react';
import { Domain } from '../../../types/interfaces';
import { useTranslation } from 'react-i18next';

interface TyposquattingData {
  fake_domain: string;
  ipv4: string;
  ns: string;
  mx: string;
  // ... demás campos
}

interface TyposquattingProps {
  selectedDomain: string | null;
  typosquattingData: TyposquattingData[];
  domains: Domain[];
  onDomainChange: (domain: string) => void;
}

const Typosquatting: React.FC<TyposquattingProps> = ({
  selectedDomain,
  typosquattingData,
  domains,
  onDomainChange,
}) => {
  const { t } = useTranslation();

  const handleDomainChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onDomainChange(e.target.value);
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-lg mb-6">
      <div className="flex items-center mb-6">
        <div className="w-3 h-10 bg-gray-800 mr-4"></div>
        <h3 className="text-4xl font-bold">{t('typosquatting.title')}</h3>
      </div>

      <p className="text-gray-700 mb-4 text-xl">
        {t('typosquatting.paragraph')}
      </p>

      {/* Selección de dominio */}
      <div className="mb-4">
        <label htmlFor="domain-select" className="block text-lg font-medium">
          <strong>{t('typosquatting.select_domain')}</strong>
        </label>
        <select
          id="domain-select"
          value={selectedDomain || ''}
          onChange={handleDomainChange}
          className="p-2 border rounded bg-gray-800 text-white font-bold w-64"
        >
          {domains.map((d) => (
            <option key={d.id} value={d.domain_name}>
              {d.domain_name}
            </option>
          ))}
        </select>
      </div>

      {/* Tabla de typosquatting */}
      <div className="overflow-x-auto bg-white p-4 rounded-lg min-h-[300px]">
        {typosquattingData.length > 0 ? (
          <table className="min-w-full text-left bg-white border rounded-lg">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="py-3 px-6 text-sm font-semibold tracking-wider text-center">
                  {t('typosquatting.table.domain')}
                </th>
                <th className="py-3 px-6 text-sm font-semibold tracking-wider text-center">
                  {t('typosquatting.table.ipv4')}
                </th>
                <th className="py-3 px-6 text-sm font-semibold tracking-wider text-center">
                  {t('typosquatting.table.ns')}
                </th>
                <th className="py-3 px-6 text-sm font-semibold tracking-wider text-center">
                  {t('typosquatting.table.mx')}
                </th>
              </tr>
            </thead>
            <tbody>
              {typosquattingData.map((item, index) => (
                <tr key={index} className="text-center bg-gray-50 even:bg-gray-100 hover:bg-gray-200">
                  <td className="py-3 px-6 border">{item.fake_domain}</td>
                  <td className="py-3 px-6 border">{item.ipv4}</td>
                  <td className="py-3 px-6 border">{item.ns}</td>
                  <td className="py-3 px-6 border">{item.mx}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="mt-4 text-center">{t('typosquatting.no_data')}</p>
        )}
      </div>
    </div>
  );
};

export default Typosquatting;
